// extracted by mini-css-extract-plugin
export default {"root":"SubHeader_root__40hNW","isDashboard":"SubHeader_isDashboard__i5SVc","isGuide":"SubHeader_isGuide__o0Mw1"};